var map = {
	"./H&M.png": 6480,
	"./Hermes.png": 4021,
	"./Maybelline.png": 7881,
	"./Olay.png": 2744,
	"./P&G.png": 8386,
	"./UNIQLO.png": 9728,
	"./adidas.png": 4671,
	"./chanel.png": 4732,
	"./ck.png": 861,
	"./clinique.png": 6767,
	"./esteelauder.png": 1022,
	"./gillete.png": 1159,
	"./lancome.png": 8114,
	"./loreal.png": 6164,
	"./lv.png": 2045,
	"./mac.png": 5942,
	"./nike.png": 2788,
	"./nudiejeans.png": 5103,
	"./peak.png": 9494,
	"./ralphlauren.png": 4779,
	"./rayban.png": 2208,
	"./shiseido.png": 5339,
	"./zara.png": 3
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 655;